import * as React from 'react';
import { useQuery } from "graphql-hooks";
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import Helper from '../../../utilities/helper'
import { useLocation } from 'react-router-dom';
import { Loading } from '../../Shared/Loading';
import { PermissionsGate } from '../../../utilities/PermissionsGate';
import { ACCESS_VALUES, PageNames } from '../../../utilities/constValues';
import { useEffect, useState } from 'react';
import { DetailView } from './DetailView';
import { PermissionsRequired } from '../../Shared/PermissionsRequired';
import { MetaTags } from "../../Shared/MetaTags";
import { useFetchWrapper } from '../../../hooks/useFetchWrapper';
import { DetailCard } from './DetailCard';
import InfiniteScroll from 'react-infinite-scroll-component';
import { LoadingCatalog } from './LoadingCatalog';
import { ErrorPage } from '../../Shared/ErrorPage';
import { Hero } from '../../Shared/Hero';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentHeading } from '../../Shared/Content/ContentHeading';
import { ContentBody } from '../../Shared/Content/ContentBody';
import { useAPIErrorContext } from '../../../contexts/apiErrorContext';


const CMS_QUERY = `query datoQuery {
    pageData: pageElectricVehicleCatalog {
        fieldBodyContent1
        fieldHeroTitle
        seo: _seoMetaTags {
            attributes
            content
            tag
        }
    }
}`;

interface IVehicleCatalogDropDown {
    dropDownField: string,
    idName: string,
    id: number,
    value: string
}

interface IVehicleCatalog {
    vehicleID: number,
    model: string,
    detailedModel: string,
    modelYear: number,
    classificationName: string,
    allElectricRange: number,
    fullRange: number,
    vehicleTypeName: string,
    vehicleSecondaryTypeName: string,
    isAvailable: boolean,
    isBuyAmericaCompliant: boolean,
    vehicleDriveTrainName: string,
    manufacturerName: string,
    expectedAvailability: number,
    batterySize: number,
    grossVehicleWeightRating: string,
    grossCarryingWeightRating: number,
    vehicleFHWAClassTypeName: string,
    msrp: number,
    seatingCapacity: number,
    citykWh100mi: number,
    highwaykWh100mi: number,
    combinedkWh100mi: number,
    imageID: string,
    imagePath: string,
    vehicleTypeImageID: string,
    vehicleTypeImagePath: string,
    manufacturerWebsiteURL: string,
    vehicleDriveTrainDescription: string
}


export const VehicleCatalog = () => {
    const { loading, error, data } = useQuery(CMS_QUERY);
    const { trackError } = useAPIErrorContext();
    const fetchWrapper = useFetchWrapper();

    const [showDetailView, setShowDetailView] = useState(false);
    const [detailViewVehicleID, setdetailViewVehicleID] = useState(0);
    const [vehicleList, setVehicleList] = useState<IVehicleCatalog[]>([]);
    const [loadingVehicleList, setLoadingVehicleList] = useState(true);
    const [vehicleListFailed, setVehicleListFailed] = useState(false);
    const [totalNumberOfVehicles, setTotalNumberOfVehicles] = useState(0);
    const [maxPageNumber, setMaxPageNumber] = useState(1);
    const [currentPageNumber, setcurrentPageNumber] = useState(1);
    const [pageNumberReset, setPageNumberReset] = useState(false);
    const [itemsPerPage] = useState(6);


    const [currentSortValue, setCurrentSortValue] = useState('availability');
    const [currentSortDirection, setCurrentSortDirection] = useState('asc');
    const [showFineTuning, setShowFineTuning] = useState(false);
    const [showMoreFilters, setShowMoreFilters] = useState(false);
    const [resetFilters, setResetFilters] = useState(false);

    const [dropDownsLoaded, setDropDownsLoaded] = useState(false);
    const [categoryList, setCategoryList] = useState<IVehicleCatalogDropDown[]>([]);
    const [categorySelection, setCategorySelection] = useState('0');
    const [vehicleTypeList, setVehicleTypeList] = useState<IVehicleCatalogDropDown[]>([]);
    const [vehicleTypeSelection, setVehicleTypeSelection] = useState('0');
    const [vehicleSubTypeList, setVehicleSubTypeList] = useState<IVehicleCatalogDropDown[]>([]);
    const [vehicleSubTypeSelection, setVehicleSubTypeSelection] = useState('0');

    const [msrpMin, setMSRPMin] = useState('');
    const [msrpMax, setMSRPMax] = useState('');
    const [minRange, setMinRange] = useState('');

    const [manufacturerList, setManufacturerList] = useState<IVehicleCatalogDropDown[]>([]);
    const [manufacturerSelection, setManufacturerSelection] = useState('0');
    const [modelList, setModelList] = useState<IVehicleCatalogDropDown[]>([]);
    const [modelSelection, setModelSelection] = useState<string>("0");

    const [seatingCapacityList, setSeatingCapacityList] = useState<IVehicleCatalogDropDown[]>([]);
    const [seatingCapacitySelection, setSeatingCapacitySelection] = useState("0");
    const [driveTrainList, setDriveTrainList] = useState<IVehicleCatalogDropDown[]>([]);
    const [driveTrainSelection, setDriveTrainSelection] = useState("0");

    const [availableModelsOnly, setAvailableModelsOnly] = useState(false);
    const [buyAmericaCompliant, setBuyAmericaCompliant] = useState(false);
    const [batteryElectricVehicle, setBatteryElectricVehicle] = useState(false);
    const [plugInHybridVehicle, setPlugInHybridVehicle] = useState(false);

    const [formErrors, setFormErrors] = useState({ msrpMinInput: '', msrpMaxInput: '', minRangeInput: '' });

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = async () => {
        setDropdownOpen(state => !state);
    }


    const drillDown = (vehicleID: number) => {
        setShowDetailView(true);
        setdetailViewVehicleID(vehicleID);
    }

    const showVehicleList = () => {
        setShowDetailView(false);
        setdetailViewVehicleID(0);
    }

    const location = useLocation();
    React.useEffect(() => {
        Helper.setPagePath(location.pathname);
    }, [location]);


    const handleMSRPMinChange = (inputValue: string | number) => {
        var errorMessage = '';
        if (isNaN(+inputValue)) {
            errorMessage = 'Input is not a number.';
        }
        else {
            setMSRPMin(inputValue.toString());
        }
        setFormErrors({
            ...formErrors,
            msrpMinInput: errorMessage
        });
    };

    const handleMSRPMaxChange = (inputValue: string | number) => {
        var errorMessage = '';
        if (isNaN(+inputValue)) {
            errorMessage = 'Input is not a number.';
        }
        else {
            setMSRPMax(inputValue.toString());
        }
        setFormErrors({
            ...formErrors,
            msrpMaxInput: errorMessage
        });
    };

    const handleMinRangeChange = (inputValue: string | number) => {
        var errorMessage = '';
        if (isNaN(+inputValue)) {
            errorMessage = 'Input is not a number.';
        }
        else {
            setMinRange(inputValue.toString());
        }
        setFormErrors({
            ...formErrors,
            minRangeInput: errorMessage
        });
    };

    const filterDropDownsByField = (array: IVehicleCatalogDropDown[], field: string) => {
        return array.filter((item) => {
            return item.dropDownField === field;
        })
    }

    const setSortingByDropDown = (sortVal: string, sortDir: string) => {
        console.log("sortValue: ", sortVal);
        console.log("sortDirection: ", sortDir);
        setCurrentSortValue(sortVal);
        setCurrentSortDirection(sortDir);
        setVehicleList([]);
        setcurrentPageNumber(1);
        setPageNumberReset(true);
    }

    const setSorting = (selection: string) => {
        var sortDirection = 'asc';
        if (selection === currentSortValue) {
            if (currentSortDirection === 'asc') {
                sortDirection = 'desc';
            }
        }
        setCurrentSortValue(selection);
        setCurrentSortDirection(sortDirection);
        setVehicleList([]);
        setcurrentPageNumber(1);
        setPageNumberReset(true);
    }

    const showHideFineTuning = (e: any) => {
        if (showFineTuning) {
            setShowFineTuning(false);
        }
        else {
            setShowFineTuning(true);
            if (!dropDownsLoaded) {
                getFilters();
            }
        }
    };

    const showHideMoreFilters = () => {
        if (showMoreFilters) {
            setShowMoreFilters(false);
        }
        else {
            setShowMoreFilters(true);
        }
    }

    const handleAvailableModelsCheck = () => {
        setAvailableModelsOnly(!availableModelsOnly);
    }

    const handleBuyAmericaCompliantCheck = () => {
        setBuyAmericaCompliant(!buyAmericaCompliant);
    }

    const handleBatteryElectricVehicleCheck = () => {
        setBatteryElectricVehicle(!batteryElectricVehicle);
    }

    const handlePlugInHybridVehicleCheck = () => {
        setPlugInHybridVehicle(!plugInHybridVehicle);
    }

    const filterResultsClick = (e: any) => {
        setcurrentPageNumber(1);
        setVehicleList([]);
        setPageNumberReset(true);
    }

    const resetClick = (e: any) => {
        setVehicleList([]);
        setVehicleSubTypeSelection("0");
        setVehicleTypeSelection("0");
        setCategorySelection("0");
        setMSRPMax("");
        setMSRPMin("");
        setMinRange("");
        setManufacturerSelection("0");
        setModelSelection("0");
        setSeatingCapacitySelection("0");
        setDriveTrainSelection("0");
        setAvailableModelsOnly(false);
        setBuyAmericaCompliant(false);
        setBatteryElectricVehicle(false);
        setPlugInHybridVehicle(false);
        setResetFilters(true);
    }

    //on category selection, load vehicle types associated with that category
    useEffect(() => {
        const getTypeFilters = () => {
            var fetchUrl = `vehiclecatalog/vehiclecatalogdropdown?vehicleCategoryID=${categorySelection}`;

            fetchWrapper.get(fetchUrl)
                .then((data) => {
                    if (data.vehicleCatalogDropDowns) {
                        var _vehicleTypeList = filterDropDownsByField(data.vehicleCatalogDropDowns, 'Type')
                        setVehicleTypeList(_vehicleTypeList);
                    }
                });
        };
        getTypeFilters();
    }, [categorySelection]);

    //on vehicle type selection, load vehicle secondary types
    useEffect(() => {
        var fetchUrl = `vehiclecatalog/vehiclecatalogdropdown?vehicleTypeID=${vehicleTypeSelection}`;

        const getSubTypeFilters = () => {
            fetchWrapper.get(fetchUrl)
                .then((data) => {
                    if (data.vehicleCatalogDropDowns) {
                        var _vehicleSecondaryTypeList = filterDropDownsByField(data.vehicleCatalogDropDowns, 'SubType')
                        setVehicleSubTypeList(_vehicleSecondaryTypeList);
                    }
                });
        };
        getSubTypeFilters();
    }, [vehicleTypeSelection]);

    //on manufacturer selection, get vehicle models
    useEffect(() => {
        const getModelFilters = () => {
            var fetchUrl = `vehiclecatalog/vehiclecatalogdropdown?manufacturerID=${manufacturerSelection}`;
            fetchWrapper.get(fetchUrl)
                .then((data) => {
                    if (data.vehicleCatalogDropDowns) {
                        var _modelList = filterDropDownsByField(data.vehicleCatalogDropDowns, 'Model');
                        setModelList(_modelList);
                    }
                });
        };
        getModelFilters();
    }, [manufacturerSelection]);

    const getFilters = () => {
        var fetchUrl = 'vehiclecatalog/vehiclecatalogdropdown';

        fetchWrapper.get(fetchUrl)
            .then((data) => {
                if (data.vehicleCatalogDropDowns) {
                    var _categoryList = filterDropDownsByField(data.vehicleCatalogDropDowns, 'Category');
                    setCategoryList(_categoryList);
                    var _vehicleTypeList = filterDropDownsByField(data.vehicleCatalogDropDowns, 'Type')
                    setVehicleTypeList(_vehicleTypeList);
                    var _vehicleSecondaryTypeList = filterDropDownsByField(data.vehicleCatalogDropDowns, 'SubType')
                    setVehicleSubTypeList(_vehicleSecondaryTypeList);
                    var _manufacturerList = filterDropDownsByField(data.vehicleCatalogDropDowns, 'Manufacturer');
                    setManufacturerList(_manufacturerList);
                    var _modelList = filterDropDownsByField(data.vehicleCatalogDropDowns, 'Model');
                    setModelList(_modelList);
                    var _seatingCapacityList = filterDropDownsByField(data.vehicleCatalogDropDowns, 'Seating Capacity');
                    setSeatingCapacityList(_seatingCapacityList);
                    var _driveTrainList = filterDropDownsByField(data.vehicleCatalogDropDowns, 'Drivetrain');
                    setDriveTrainList(_driveTrainList);
                }
            });
        setDropDownsLoaded(true);
    };

    const setFilterSortParametersQueryString = () => {
        var queryString = '';
        var filterParams = [];
        if (categorySelection && categorySelection !== "0") {
            filterParams.push(`vehicleCategoryID=${categorySelection}`);
        }
        if (vehicleTypeSelection && vehicleTypeSelection !== "0") {
            filterParams.push(`vehicleTypeID=${vehicleTypeSelection}`);
        }
        if (vehicleSubTypeSelection && vehicleSubTypeSelection !== "0") {
            filterParams.push(`vehicleSecondaryTypeID=${vehicleSubTypeSelection}`);
        }
        if (msrpMin) {
            filterParams.push(`msrpMin=${msrpMin}`);
        }
        if (msrpMax) {
            filterParams.push(`msrpMax=${msrpMax}`);
        }
        if (minRange) {
            filterParams.push(`minRange=${minRange}`);
        }
        if (manufacturerSelection && manufacturerSelection !== "0") {
            filterParams.push(`ManufacturerID=${manufacturerSelection}`);
        }
        if (modelSelection && modelSelection !== "0") {
            var encodedMSelection = encodeURIComponent(modelSelection);
            filterParams.push(`vehicleModel=${encodedMSelection}`);
        }
        if (seatingCapacitySelection && seatingCapacitySelection !== "0") {
            var cleanedSeatingCapacity = seatingCapacitySelection.replace("+", "%2b");
            filterParams.push(`seatingCapacity=${cleanedSeatingCapacity}`);
        }
        if (driveTrainSelection && driveTrainSelection !== "0") {
            filterParams.push(`vehicleDriveTrainID=${driveTrainSelection}`);
        }
        if (availableModelsOnly) {
            filterParams.push(`isAvailable=${availableModelsOnly}`);
        }
        if (buyAmericaCompliant) {
            filterParams.push(`isBuyAmericaCompliant=${buyAmericaCompliant}`);
        }
        if (batteryElectricVehicle) {
            filterParams.push(`isBEV=${batteryElectricVehicle}`);
        }
        if (plugInHybridVehicle) {
            filterParams.push(`isPHEV=${plugInHybridVehicle}`);
        }
        //sort, page and page size always have values
        filterParams.push(`sortBy=${currentSortValue}`);
        filterParams.push(`sortOrder=${currentSortDirection}`);
        filterParams.push(`pageNumber=${currentPageNumber}`);
        filterParams.push(`itemsPerPage=${itemsPerPage}`);

        queryString = filterParams.join('&');
        return queryString;
    };

    const getVehicleList = () => {
        setLoadingVehicleList(true);
        var fetchUrl = `vehiclecatalog?${setFilterSortParametersQueryString()}`;

        fetchWrapper.get(fetchUrl)
            .then((data) => {
                if (data.vehicleCatalog) {
                    setVehicleList(prevItems => [...prevItems, ...data.vehicleCatalog])
                    setcurrentPageNumber(prevPage => prevPage + 1);
                    setTotalNumberOfVehicles(data.totalNumberOfVehicles);
                    setMaxPageNumber(data.maxPageNumber);
                    setLoadingVehicleList(false);
                }
                else {
                    //the vehicle list is the bulk of the page, so show the error page rather than an empty catalog
                    trackError("Vehicle catalog error", JSON.stringify(data));
                    setVehicleListFailed(true);
                }
            }).catch((error: any) => {
                trackError("Vehicle catalog error", JSON.stringify(error));
                setVehicleListFailed(true);
            });
    };

    useEffect(() => {
        getVehicleList();
    }, []);

    useEffect(() => {
        if (pageNumberReset) {
            getVehicleList();
            setPageNumberReset(false);
        }
    }, [pageNumberReset]);

    useEffect(() => {
        if (resetFilters) {
            setcurrentPageNumber(1);
            setPageNumberReset(true);
            setResetFilters(false);
        }
    }, [resetFilters]);


    if (vehicleListFailed) {
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
    else if (!error && !loading) {
        return (
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.VehicleCatalog}>
                <div className="evCatalogContainer">
                    <Hero pageTitle={data.pageData.fieldHeroTitle} />
                    {!showDetailView ? (
                        <div className="vehicleCatalogListView">
                            <Row>
                                <Col className="pageAnchorsBody">
                                    <Row className="pageAnchorsSection desktopView">
                                        <Col lg={8} md={8} className="inPageNav" >
                                            <span className="sortByTitle">Sort by:</span>
                                            <Button className={`buttonAsLink sorting ${currentSortValue === 'availability' ? 'active' : ''} ${currentSortDirection}`} onClick={e => setSorting("availability")}>Availability</Button>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <Button className={`buttonAsLink sorting ${currentSortValue === 'cost' ? 'active' : ''} ${currentSortDirection}`} onClick={e => setSorting("cost")}>Cost</Button>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <Button className={`buttonAsLink sorting ${currentSortValue === 'manufacturer' ? 'active' : ''} ${currentSortDirection}`} onClick={e => setSorting("manufacturer")}>Manufacturer</Button>
                                        </Col>
                                        <Col lg={4} md={4} className="nextPageNav">
                                            <Button className={`buttonAsLink ${showFineTuning ? 'active' : ''} openCloseChevron `} onClick={showHideFineTuning}>Fine Tune These Results</Button>
                                        </Col>
                                    </Row>
                                    <Row className="pageAnchorsSection mobileView">
                                        <Col sm={12} className="inPageNav" >
                                            <Dropdown id="pageAnchorsDropDown" className="pageAnchorsDropDown" direction="down" isOpen={dropdownOpen} toggle={toggleDropdown}>
                                                <DropdownToggle caret>
                                                    Sort by...&nbsp;
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem className={`sortingItem  ${currentSortValue === 'availability' && currentSortDirection === 'asc' ? 'active' : ''}`} >
                                                        <div className="dateSortAscending" onClick={e => setSortingByDropDown("availability", "asc")}>Availability By Year</div>
                                                    </DropdownItem>
                                                    <DropdownItem className={`sortingItem  ${currentSortValue === 'availability' && currentSortDirection === 'desc' ? 'active' : ''}`} >
                                                        <div className="dateSortDescending" onClick={e => setSortingByDropDown("availability", "desc")}>Availability By Year</div>
                                                    </DropdownItem>
                                                    <DropdownItem className={`sortingItem  ${currentSortValue === 'cost' && currentSortDirection === 'asc' ? 'active' : ''}`} >
                                                        <div onClick={e => setSortingByDropDown("cost", "asc")}>Cost, Low to High</div>
                                                    </DropdownItem>
                                                    <DropdownItem className={`sortingItem  ${currentSortValue === 'cost' && currentSortDirection === 'desc' ? 'active' : ''}`} >
                                                        <div onClick={e => setSortingByDropDown("cost", "desc")}>Cost, High to Low</div>
                                                    </DropdownItem>
                                                    <DropdownItem className={`sortingItem  ${currentSortValue === 'manufacturer' && currentSortDirection === 'asc' ? 'active' : ''}`} >
                                                        <div onClick={e => setSortingByDropDown("manufacturer", "asc")}>Manufacturer A-Z</div>
                                                    </DropdownItem>
                                                    <DropdownItem className={`sortingItem  ${currentSortValue === 'manufacturer' && currentSortDirection === 'desc' ? 'active' : ''}`} >
                                                        <div onClick={e => setSortingByDropDown("manufacturer", "desc")}>Manufacturer Z-A</div>
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </Col>
                                        <Col sm={12} className="nextPageNav">
                                            <Button className={`buttonAsLink ${showFineTuning ? 'active' : ''} openCloseChevron `} onClick={showHideFineTuning}>Fine Tune These Results</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            {showFineTuning ? (
                                <ContentBlock className="filterControl">
                                    <Card>
                                        <CardHeader>
                                            <Row className="closeButtonRow">
                                                <Col>
                                                    <div>{totalNumberOfVehicles} listings match this criteria</div>
                                                </Col>
                                                <Col className="text-align-right">
                                                    <Button className="submitButton hollowNeg secondaryButton iconCloseX" onClick={showHideFineTuning}></Button>
                                                </Col>
                                            </Row>
                                        </CardHeader>
                                        <CardBody>
                                            <Form>
                                                <Row>
                                                    <Col className="twoColumnMaxWidth">
                                                        <Row>
                                                            <Col lg={6} md={6} sm={12} xs={12} className="twoColumnInputs">
                                                                <FormGroup row className="form-group">
                                                                    <Label for="category" lg={5} md={4} className="">Category</Label>
                                                                    <Col lg={7} md={8}>
                                                                        <Input className="fieldWidth215" type="select" name="category" id="category" value={categorySelection} onChange={e => setCategorySelection(e.target.value)}>
                                                                            <option key="0" value="0">
                                                                                All
                                                                            </option>
                                                                            {categoryList.map((option: IVehicleCatalogDropDown) => {
                                                                                return (
                                                                                    <option key={option.id} value={option.id}>
                                                                                        {option.value}
                                                                                    </option>)
                                                                            })};
                                                                        </Input>
                                                                    </Col>
                                                                </FormGroup>
                                                                <FormGroup row className="form-group">
                                                                    <Label for="vType" lg={5} md={4} className="">Type</Label>
                                                                    <Col lg={7} md={8}>
                                                                        {vehicleTypeList && categorySelection !== "0" ? (
                                                                            <Input className="fieldWidth215" type="select" name="vType" id="vType" value={vehicleTypeSelection} onChange={e => setVehicleTypeSelection(e.target.value)}>
                                                                                <option key="0" value="0">
                                                                                    All
                                                                                </option>
                                                                                {vehicleTypeList.map((option: IVehicleCatalogDropDown) => {
                                                                                    return (
                                                                                        <option key={option.id} value={option.id}>
                                                                                            {option.value}
                                                                                        </option>)
                                                                                })};
                                                                            </Input>
                                                                        ) : (
                                                                            <Input className="fieldWidth215" type="select" name="vType" id="vType" value={vehicleSubTypeSelection} disabled>
                                                                                <option key="0" value="0" disabled>
                                                                                    All
                                                                                </option>
                                                                            </Input>
                                                                        )}
                                                                    </Col>
                                                                </FormGroup>
                                                                <FormGroup row className="form-group">
                                                                    <Label for="subType" lg={5} md={4} className="">Subtype</Label>
                                                                    <Col lg={7} md={8}>
                                                                        {vehicleSubTypeList && vehicleTypeSelection !== "0" ? (
                                                                            <Input className="fieldWidth215" type="select" name="subType" id="subType" value={vehicleSubTypeSelection} onChange={e => setVehicleSubTypeSelection(e.target.value)}>
                                                                                <option key="0" value="0">
                                                                                    All
                                                                                </option>
                                                                                {vehicleSubTypeList.map((option: IVehicleCatalogDropDown) => {
                                                                                    return (
                                                                                        <option key={option.id} value={option.id}>
                                                                                            {option.value}
                                                                                        </option>)
                                                                                })};
                                                                            </Input>
                                                                        ) : (
                                                                            <Input className="fieldWidth215" type="select" name="subType" id="subType" value={vehicleSubTypeSelection} disabled>
                                                                                <option key="0" value="0" disabled>
                                                                                    All
                                                                                </option>
                                                                            </Input>
                                                                        )}
                                                                    </Col>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg={6} md={6} sm={12} xs={12} className="twoColumnInputs">
                                                                <FormGroup row >
                                                                    <Label for="msrpStart" lg={4} md={6} className=" ">Minimum MSRP $</Label>
                                                                    <Col lg={8} md={6}>
                                                                        <Input className="fieldWidth100 inlineInput" type="text" name="msrpStart" id="msrpStart" placeholder="" value={msrpMin} onChange={e => handleMSRPMinChange(e.target.value)} maxLength={10} />
                                                                    </Col>
                                                                </FormGroup>
                                                                <FormGroup row >
                                                                    <Label for="msrpEnd" lg={4} md={6} className=" ">Maximum MSRP $</Label>
                                                                    <Col lg={8} md={6}>
                                                                        <Input className="fieldWidth100 inlineInput" type="text" name="msrpEnd" id="msrpEnd" placeholder="" value={msrpMax} onChange={e => handleMSRPMaxChange(e.target.value)} maxLength={10} />
                                                                    </Col>
                                                                </FormGroup>
                                                                <FormGroup row >
                                                                    <Label for="minRange" lg={4} md={6} className=" ">Minimum Range</Label>
                                                                    <Col lg={8} md={6}>
                                                                        <Input className="fieldWidth100 inlineInput" type="text" name="minRange" id="minRange" placeholder="" value={minRange} onChange={e => handleMinRangeChange(e.target.value)} maxLength={4} />
                                                                        <span className="regFont">miles</span>
                                                                    </Col>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Button className={`buttonAsLink moreFiltersButton openCloseChevron ${showMoreFilters ? 'active' : ''}`} onClick={showHideMoreFilters}>More filters</Button>
                                                </Row>
                                                {showMoreFilters ? (
                                                    <Row>
                                                        <Col className="threeColumnMaxWidth">
                                                            <Row>
                                                                <Col lg={4} md={6} sm={12} xs={12} className="threeColumnInputs first">
                                                                    <FormGroup row className="form-group">
                                                                        <Label for="manufacturer" sm={4} className="">Manufacturer</Label>
                                                                        <Col sm={8}>
                                                                            <Input className="fieldWidth215" type="select" name="manufacturer" id="manufacturer" value={manufacturerSelection} onChange={e => setManufacturerSelection(e.target.value)}>
                                                                                <option key="0" value="0">
                                                                                    All
                                                                                </option>
                                                                                {manufacturerList.map((option: IVehicleCatalogDropDown) => {
                                                                                    return (
                                                                                        <option key={option.id} value={option.id}>
                                                                                            {option.value}
                                                                                        </option>)
                                                                                })};
                                                                            </Input>
                                                                        </Col>
                                                                    </FormGroup>
                                                                    <FormGroup row className="form-group">
                                                                        <Label for="model" sm={4} className="">Model</Label>
                                                                        <Col sm={8}>
                                                                            {modelList && manufacturerSelection !== "0" ? (
                                                                                <Input className="fieldWidth215" type="select" name="model" id="model" value={modelSelection} onChange={e => setModelSelection(e.target.value)}>
                                                                                    <option key="0" value="0">
                                                                                        All
                                                                                    </option>
                                                                                    {modelList.map((option: IVehicleCatalogDropDown) => {
                                                                                        return (
                                                                                            <option key={option.value} value={option.value}>
                                                                                                {option.value}
                                                                                            </option>)
                                                                                    })};
                                                                                </Input>
                                                                            ) : (
                                                                                <Input className="fieldWidth215" type="select" name="model" id="model" value={modelSelection} disabled>
                                                                                    <option key="0" value="0">
                                                                                        All
                                                                                    </option>
                                                                                </Input>
                                                                            )}
                                                                        </Col>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg={4} md={6} sm={12} xs={12} className="threeColumnInputs">
                                                                    <FormGroup row className="form-group">
                                                                        <Label for="seatingCapacity" sm={4} className="long">Seating Capacity</Label>
                                                                        <Col sm={8}>
                                                                            <Input className="fieldWidth215" type="select" name="seatingCapacity" id="seatingCapacity" value={seatingCapacitySelection} onChange={e => setSeatingCapacitySelection(e.target.value)}>
                                                                                <option key="0" value="0">
                                                                                    All
                                                                                </option>
                                                                                {seatingCapacityList.map((option: IVehicleCatalogDropDown) => {
                                                                                    return (
                                                                                        <option key={option.value} value={option.value}>
                                                                                            {option.value}
                                                                                        </option>)
                                                                                })};
                                                                            </Input>
                                                                        </Col>
                                                                    </FormGroup>
                                                                    <FormGroup row className="form-group">
                                                                        <Label for="driveTrain" sm={4} className="">Drivetrain</Label>
                                                                        <Col sm={8}>
                                                                            <Input className="fieldWidth215" type="select" name="driveTrain" id="driveTrain" value={driveTrainSelection} onChange={e => setDriveTrainSelection(e.target.value)}>
                                                                                <option key="0" value="0">
                                                                                    All
                                                                                </option>
                                                                                {driveTrainList.map((option: IVehicleCatalogDropDown) => {
                                                                                    return (
                                                                                        <option key={option.id} value={option.id}>
                                                                                            {option.value}
                                                                                        </option>)
                                                                                })};
                                                                            </Input>
                                                                        </Col>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col lg={4} md={12} sm={12} xs={12} className="threeColumnInputs last">
                                                                    <FormGroup check>
                                                                        <Input type="checkbox" className="checkbox" name="availableModels" id="availableModels" checked={availableModelsOnly} onChange={handleAvailableModelsCheck} />
                                                                        <Label check>
                                                                            Available models only
                                                                        </Label>
                                                                    </FormGroup>
                                                                    <FormGroup check className="extraBottom">
                                                                        <Input type="checkbox" className="checkbox" name="buyAm" id="buyAm" checked={buyAmericaCompliant} onChange={handleBuyAmericaCompliantCheck} />
                                                                        <Label check>
                                                                            Buy America compliant
                                                                        </Label>
                                                                    </FormGroup>
                                                                    <FormGroup check>
                                                                        <Input type="checkbox" className="checkbox" name="bev" id="bev" checked={batteryElectricVehicle} onChange={handleBatteryElectricVehicleCheck} />
                                                                        <Label check>
                                                                            Battery-electric vehicle
                                                                        </Label>
                                                                    </FormGroup>
                                                                    <FormGroup check>
                                                                        <Input type="checkbox" className="checkbox" name="pihv" id="pihv" checked={plugInHybridVehicle} onChange={handlePlugInHybridVehicleCheck} />
                                                                        <Label check>
                                                                            Plug-in hybrid vehicle
                                                                        </Label>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                ) : (<></>)}
                                            </Form>

                                        </CardBody>
                                        <CardFooter>
                                            <Row className="submitButtonRow">
                                                <Col>
                                                    <Button className="submitButton hollowPos secondaryButton iconResetBlack" onClick={resetClick}>Reset</Button>
                                                </Col>
                                                <Col>
                                                    <Button type="button" className="solidNeg secondaryButton iconView btn btn-secondary" onClick={filterResultsClick}>Show Results</Button>
                                                </Col>
                                            </Row>
                                        </CardFooter>
                                    </Card>
                                </ContentBlock>
                            ) : ('')}
                            <ContentBlock className="vehicleCatalogContentBlock">
                                <ContentBody>
                                    <div className="sectionPadding contentBlock">
                                        <div dangerouslySetInnerHTML={{ __html: data.pageData.fieldBodyContent1 }} />
                                    </div>
                                    {vehicleList ? (
                                        <InfiniteScroll dataLength={vehicleList.length} next={getVehicleList}
                                            hasMore={currentPageNumber <= maxPageNumber}
                                            loader={<LoadingCatalog />}
                                            endMessage={(loadingVehicleList ? <LoadingCatalog /> : <></>)} >
                                            <Row className="contentBlock vehicleList">
                                                {vehicleList.map((item: IVehicleCatalog, index: number) => {
                                                    return (
                                                        <Col lg={4} md={6} sm={12} className="detailCol" key={index}>
                                                            <DetailCard vehicleDetail={item} drillDownCallback={drillDown} />
                                                        </Col>
                                                    )
                                                })}
                                            </Row>

                                        </InfiniteScroll>
                                    ) : (
                                        <Row className="contentBlock">
                                            <Col></Col>
                                        </Row>
                                    )}
                                    </ContentBody>
                             </ContentBlock>
                        </div>
                    ) : (
                        <DetailView vehicleID={detailViewVehicleID} closeCallback={showVehicleList} />
                    )}

                    {/* set meta tags */}
                    <MetaTags seoData={data.pageData.seo} />

                </div>
            </PermissionsGate>
        );
    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
};
